import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import { Menu, SystemConfigurationMenu } from "../menu/Menu";
import { AppIcons } from "../../../data/appIcons";
import SideBarMenuItem from "./SideBarMenuItem";
import SideBarSubMenuItem from "./SideBarSubMenuItem";
import { logout } from "../../../app/slice/authSlice";
import { useDispatch } from "react-redux";
import Image from "../../../components/image/Image";
import { IsAuthorizeUser } from "../../../lib/authenticationLibrary";
import { hasFunctionalPermission, hasPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";
import Iconify from "../../../components/FinalForms/ui/iconify/Iconify";
import { securityKey } from "../../../data/SecurityKey";

const Sidebar = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const menuItem = location.pathname;
    const [clickedValue, setClickedValue] = useState(null);
    const [clickedValueSubMenu, setClickedValueSubMenu] = useState(null);
    const [navigationMenuList, setNavigationMenuList] = useState(Menu);
    const [isCustomSidebarVisible, setIsCustomSidebarVisible] = useState(false);
    const [hasButtonPermission, setHasButtonPermission] = useState(false);
    const hasAddPermission = hasFunctionalPermission(securityKey.RECYCLEBIN);


    useEffect(() => {
        if (hasAddPermission?.hasAccess) {
          setHasButtonPermission(true);
        } else {
          setHasButtonPermission(false);
        }
      }, [hasAddPermission]);
    


    const handleItemClick = (item) => {
        if (clickedValue === item) {
            setClickedValue(null);
        } else {
            setClickedValue(item);
        }
    };

    const handleSubItemClick = (e, item) => {
        setClickedValueSubMenu(item);
        e.stopPropagation();
    };
    const handleClick = (menuId) => {
        setClickedValue((prevSelectedMenu) =>
          prevSelectedMenu === menuId ? null : menuId
        );
      };
    useEffect(() => {

        if (menuItem.startsWith("/SystemConfiguration")) {
          setIsCustomSidebarVisible(true);
          setNavigationMenuList(SystemConfigurationMenu);
    
          if (menuItem.startsWith("/SystemConfiguration/InterviewRound")) {
            handleClick(SystemConfigurationMenu[0].id);
          }
        } 
        else {
            setNavigationMenuList(Menu);
            setIsCustomSidebarVisible(false);
          }
      }, [menuItem, SystemConfigurationMenu]);


      const handleBackButtonClick = () => {
        setIsCustomSidebarVisible(false);
        if (menuItem.startsWith("/SystemConfiguration")) {
          navigate("/");
          setNavigationMenuList(Menu);
          handleClick(Menu[0].id);
        } 
      };

    return (
        <div className={`sidebar-section`}>
            <div className="sidebar-logo">
                <div className="logo-part">
                    <Link to={"/"}>
                        <Image
                            imgCustomClassName="default-logo"
                            imagePath={AppIcons.logoImage}
                            altText="Logo"
                        />
                        <Image
                            imgCustomClassName="collapse-logo"
                            imagePath={AppIcons.smallLogoImg}
                            altText="Logo"
                        />
                    </Link>
                </div>
            </div>
            <div className="menu-list-items">
                <ul>
                {isCustomSidebarVisible && (
                <div className="sidebar-back-btn">
                 
                  <li
                    className="menu-item mt-4"
                    onClick={handleBackButtonClick}
                  >
                    <Link>
                     
                      <Iconify icon="lets-icons:back" />
                      <span>Back to Main Menu</span>
                    </Link>
                  </li>
                </div>
              )}
                    {navigationMenuList.map((item, Index) => (
                        <>
                            {IsAuthorizeUser(item.Role) !== undefined ? (
                                <>
                                    {item.children.length > 0
                                        ?
                                        (
                                            <li
                                                key={Index}
                                                className={`${clickedValue === item ? "active" : ""}`}
                                                onClick={() => handleItemClick(item)}
                                            >
                                                <SideBarMenuItem
                                                    image={item.image}
                                                    name={item.name}
                                                    securityKey={item.securityKey}
                                                    childLength={item.children.length}
                                                />
                                                <SideBarSubMenuItem
                                                    childItems={item.children}
                                                    handleSubItemClick={handleSubItemClick.bind(this)}
                                                    clickedValueSubMenu={clickedValueSubMenu}
                                                />
                                            </li>
                                        )
                                        :
                                        hasPermission(item.securityKey) ? (

                                            <li
                                                key={Index}
                                                className={`${clickedValue === item ? "active" : ""}`}
                                                onClick={() => handleItemClick(item)}
                                            >
                                                <Link to={item.to}>
                                                    <span>
                                                        <Image imagePath={item.image} altText="Menu Icon" />
                                                        {item.name}
                                                    </span>
                                                </Link>
                                            </li>
                                        ) : null
                                    }
                                </>
                            ) : null}
                        </>
                    ))}
                </ul>
                <div className="logout-btn-sec">
                    <ul>
                        <li>
                            <button onClick={() => dispatch(logout())}>
                                <Image imagePath={AppIcons.logoutMenu} altText="Logout Icon" />
                                <span className="logout-text">Logout</span>
                            </button>
                        </li>
                        {
                            hasButtonPermission ? 
                            <li title="Recycle Bin">
                            <Link to={"/RecycleBinDelete"}>
                                <Image imagePath={AppIcons.BinIcon} altText="Logout Icon" />
                            </Link>
                        </li> : null
                        }
                        
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
